/* eslint-disable */
import { GetterTree } from "vuex";
import { Ticket } from "@/models/ticket";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { TicketState } from "@/types/ticket";

const getters: GetterTree<TicketState, RootState> = {
  list: (state) => {
    return state.pagination ? state.pagination.data : [];
  },
  pagination: (state) => {
    return state.pagination || new Pagination();
  },
  single: (state) => {
    return state.single || new Ticket();
  },
  selectItem: (state) => {
    return state.pagination
      ? state.pagination.data.map((ticket) => Ticket.toSelectItem(ticket))
      : [];
  },
  find: (state) => (id: number) => {
    return state.pagination
      ? state.pagination.data.find((ticket) => {
          return ticket.id == id;
        })
      : new Ticket();
  },
};

export default getters;
